import { Permissions } from "@shared/models/enums/permissions.enum";

export const PERMISSIONS_CONFIG = [
  {
    header: 'cms',
    icon: 'pen',
    actions: [
      {
        title: 'booking',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewBookingCms },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateBookingCms },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'media',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewMediaCms },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateMediaCms },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'mediaTransfer',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewMediaTransfer },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateMediaTransfer },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'widgets',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: 'ViewWidgets' },
          { label: 'edit', value: true, hiddenValue: 'UpdateWidgets' },
        ],
      },
    ],
  },
  {
    header: 'analytics',
    icon: 'exposures-reports',
    actions: [
      {
        title: 'reach',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewReachAnalytics },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'reachReports',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewReachReportsAnalytics },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: true, hiddenValue: Permissions.ExportReachReportsAnalytics },
        ],
      },
      {
        title: 'campaign',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewExposuresAnalytics },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'campaignReports',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewExposuresReportsAnalytics },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: true, hiddenValue: Permissions.ExportExposuresReportsAnalytics },
        ],
      },
      {
        title: 'campaignSendouts',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewCampaignSendouts },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateCampaignSendouts },
          { label: 'export', value: true, hiddenValue: Permissions.ExportCampaignSendouts },
        ],
      },
      {
        title: 'forecast',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewForecastAnalytics },
        ],
      },
      {
        title: 'forecastEvent',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewForecastEventAnalytics },
          { label: 'edit', value: null, hiddenValue: Permissions.UpdateForecastEventAnalytics },
        ],
      },
    ],
  },
  {
    header: 'visitorInsights',
    icon: 'people-counter',
    actions: [
      {
        title: 'peopleCounter',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewPeopleCounterInsights },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'peopleCounterReports',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewPeopleCounterReportsInsights },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: true, hiddenValue: Permissions.ExportPeopleCounterReportsInsights },
        ],
      },
      {
        title: 'poi',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewPoiInsights },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdatePoiInsights },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'poiCategories',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewPoiCategoriesInsights },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdatePoiCategoriesInsights },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'poiReports',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewPoiReportsInsights },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: true, hiddenValue: Permissions.ExportPoiReportsInsights },
        ],
      },
    ],
  },
  {
    header: 'admin',
    icon: 'shield',
    actions: [
      {
        title: 'sms',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewSmsAdmin },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'channels',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewChannelAdmin },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateChannelAdmin },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'poi',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewPoiInsights },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdatePoiInsights },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'devices',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewScreensAdmin },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateScreensAdmin },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'devicesReports',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewDevicesReportsAdmin },
          { label: 'edit', value: null, hiddenValue: null },
          { label: 'export', value: true, hiddenValue: Permissions.ExportDevicesReportsAdmin },
        ],
      },
      {
        title: 'clients',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewClientsAdmin },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateClientsAdmin },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'contactPersons',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewContactPersonAdmin },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateContactPersonAdmin },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'users',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewUsersAdmin },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateUsersAdmin },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
      {
        title: 'usersPermissions',
        icon: '',
        permissions: [
          { label: 'view', value: true, hiddenValue: Permissions.ViewUserPermissionsAdmin },
          { label: 'edit', value: true, hiddenValue: Permissions.UpdateUserPermissionsAdmin },
          { label: 'export', value: null, hiddenValue: null },
        ],
      },
    ],
  },
];
